"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandTypes = void 0;
exports.CommandTypes = {
    Bet: "bet",
    Hit: "hit",
    Stand: "stand",
    Double: "double",
    Split: "split",
};
